let state_data = {
    'first_report': false,
    'option_icon': false,
    'modify_option': false,
    'update_data': false
}

const workspaceReduser = (state = state_data, action) => {
    switch (action.type) {
        case "FIRST_REPORT_POPOVER":
            return action.payload
        case "OPTION_ICON_POPOVER":
            return action.payload
        case "MODIFY_OPTION_POPOVER":
            return action.payload
        case "UPDATE_DATA_OPTION_POPOVER":
            return action.payload
        case "DEFAULT_REPORT_POPOVER":
            return action.payload
        default: return state
    }
}

export default workspaceReduser;